<template>
  <router-view></router-view>
  <!-- <div class="body">
    <div class="logo"></div>
    <div id="login-mod-wrapper" v-show="login" class="login-mod-wrapper login-mod-form login-mod-wrapper-3"
         style="background-image: none;background-color: rgb(255, 255, 255);cursor: default;">
      <div class="mod login-mod login-mod-multidomain">
        <div name="loginform" id="loginform">
          <h2>身份认证</h2>
          <div class="fi">
            <label class="tit">学　号</label>
            <input type="text" id="account_name" class="ipt-t ipt-sample" placeholder="学号" v-model="account">
          </div>
          <div class="fi">
            <label class="tit">姓　名</label>
            <input type="text" id="user_name" class="ipt-t ipt-sample" placeholder="姓名" v-model="account">
          </div>
          <div class="fi">
            <label class="tit">手机号</label>
            <input type="text" id="telephone" class="ipt-t ipt-sample" placeholder="校友会系统手机号" v-model="account">
          </div>
          <div class="fi">
            <label class="tit">验证码</label>
            <input type="text" id="verification_code" class="ipt-t ipt-sample" placeholder="请输入验证码" v-model="account">
            <button id="count" v-show="show" @click="getCode">获取验证码</button>
	          <button v-show="!show" class="count">{{count}} s</button>
          </div>
          <div class="fi fi-notit f-cb">
            <input class="red_btn" value="认　证" style="float:left;" id="submit-btn" @click="verifyAccount">
          </div>
        </div>
      </div>
    </div>
    <div class="footer">杭州电子科技大学信息技术中心@Copyright Tel:0571-86878568</div>
    <Alu v-show="visible" ref="alu"></Alu>
  </div> -->
</template>

<!-- <script>
import axios from 'axios'
import Alu from '../src/components/Alu'
import baseUrl from "@/net/baseUrl";

export default {
  name: "App",
  components: {
    Alu,
  },
  data() {
    return {
      account: '',
      password: '',
      visible:false,
      login: true,
      user: {},
      show: true,
	    count: '',
	    timer: null
    }
  },

  methods: {
    verifyAccount() {
      axios({
        url: baseUrl + 'email/user', method: 'post', data: {
          idNumber: this.account, userPwd: this.password
        }
      }).then(res => {
        const user = res.data;
        if (user.code === 200) {
          this.user = user.data;
          // 登录成功，查看该工号是否注册过邮箱
          axios({
            url: baseUrl + 'email/account/getAccount', method: 'post', data: {
              idNumber: this.account
            }
          }).then(res => {
            console.log(res.data);
            if (res.data.code === 200){
              alert("账号已注册!!!");
            } else if (res.data.code === 10003){
              // 未注册账号，需要注册
              axios({
                url: baseUrl + 'email/account/createAccount', method: 'post', data: {
                  idNumber: this.user.idNumber, userPwd: this.user.userPwd,
                  userName: this.user.userName, unitUid: this.user.unitUid,
                  idType: this.user.idType
                }
              }).then(res => {
                console.log(res.data);
                if (res.data.code === 200) {
                  this.visible = true;
                  this.login = false;
                  this.$nextTick(() => {
                    this.$refs.alu.init(this.user);
                  })
                } else {
                  alert(res.data.errorMsg);
                }
              }).catch(err => {
                console.log(err);
              });
            } else {
              alert(res.data.errorMsg);
            }
          }).catch(err => {
            console.log(err);
            alert('系统错误！！');
          });
        } else {
          alert(user.errorMsg)
        }
      }).catch(err => {
        console.log(err);
        alert('系统错误！！')
      });
    },

    getCode(){
	      const TIME_COUNT = 60;
	      if (!this.timer) {
	        this.count = TIME_COUNT;
	        this.show = false;
	        this.timer = setInterval(() => {
	        if (this.count > 0 && this.count <= TIME_COUNT) {
	          this.count--;
	         } else {
	          this.show = true;
	          clearInterval(this.timer);
	          this.timer = null;
	         }
	        }, 1000)
	       }
	    }
  }
}
</script>

<style scoped>
.body {
  width: 100%;
  height: 100%;
  margin: -8px;
  position: fixed;
  background-image: url('img/background.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
  font: 13px 'Helvetica Neue',Helvetica,Arial,Sans-serif;
  color: #707070;
  display: flex;

  /* filter: gray !important; 
    filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1); 
    filter: grayscale(100%); 
    -webkit-filter: grayscale(100%); 
    -moz-filter: grayscale(100%); 
    -ms-filter: grayscale(100%); 
    -o-filter: grayscale(100%);  */
}
.logo{
  background-image: url('img/logo.png');
  background-repeat: no-repeat;
  width: 473px;
  height: 70px;
  position:absolute;
  top:80px;
  left:80px;
}
form {
  margin: 0;
  padding: 0;
  border: 0;
  display: block;
}

input {
  font: 13px 'Helvetica Neue',Helvetica,Arial,Sans-serif;
  vertical-align: middle;
  writing-mode: horizontal-tb !important;
  text-rendering: auto;
  letter-spacing: normal;
  word-spacing: normal;
  text-transform: none;
  text-indent: 0px;
  text-shadow: none;
  text-align: start;
  -webkit-rtl-ordering: logical;
  margin: 0em;
}

.body .login-mod-multidomain {
  padding: 10px 20px!important;
}

.body .login-mod-multidomain {
  padding: 18px 25px;
}

.login-mod {
  position: static;
  width: auto!important;
  /*height: 313px;*/
  top: 35px;
  left: 505px;
}

.login-mod-wrapper-3 {
  left: auto!important;
}

.login-mod-form {
  background: rgba(255,255,255,.8) no-repeat!important;
  border-radius: 4px;
}

.login-mod-wrapper {
  /*height: 250px;*/
  width: 413px;
  margin: auto auto !important;
  /*position: absolute;*/
  /*top: 84px;*/
  /*right: 800px;*/
}

div {
  display: block;
}

.login-mod h2 {
  text-indent: 0;
  text-align: left;
  padding: 20px 0px 10px 0px;
  line-height: 30px;
  font-size: 18px;
  font-weight: normal;
  color: #121212;
  background-image: none;
  background-repeat: no-repeat;
  background-position: -252px -36px;
  width: 151px;
  height: 30px;
  overflow: hidden;
  margin: 0 10px;
  border: 0;
  display: block;
}

.login-mod .fi {
  padding: 10px 0;
  margin: 0 20px;
  float: left;
}

.fi {
  padding: 5px 0 !important;
}
#verification_code {
  width: 35%;
  float: left;
}
.login-mod .fi button{
  width:32%;
  height: 30px;
  border:1px solid #0063ba;
  background-color: #fff;
  color: #0063ba; 
  float: left;
  cursor: pointer;
  font-size: 14px;
}
.login-mod label.tit {
  float: left;
  _margin-right: -3px;
  width: 66px;
  line-height: 29px;
  color: #000;
}

label {
  text-decoration: none;
  border: none;
  cursor: default;
}

.login-mod .ipt-sample {
  color: #788F9E;
}

.login-mod .ipt-t {
  width: 235px;
  border: 1px solid #7A8395;
  padding: 6px 4px;
  font-size: 14px;
  margin-right: 10px;
  font-family: Arial,sans-serif;
}

.login-mod .fi-notit {
  padding-left: 4em;
  position: relative;
  margin-bottom: 20px;
}

.red_btn {
  float: none!important;
  width: 300px;
  height: 36px;
  background-color: #0063ba;
  cursor: pointer;
  border: 1px solid transparent;
  color: #fff;
  font-size: 14px;
  padding: 0px 15px;
  margin-top: 10px;
  text-align: center;
  font-size: 14px;
}
.footer{
  color: #fff;
  position: absolute;
  left:80px;
  bottom: 50px;
}
</style> -->
